/* =========================================================================
   assets/fit-concierge.js
   Provador Virtual — estimativa antropométrica em 3 passos.
   Lógica portada de src/components/site/provador/anthropometry.ts
   para JS de tema. Lê custom.medidas_min / custom.medidas_max do produto.
   ========================================================================= */

/* Regressão antropométrica simplificada (mesmas constantes do original):
   estimativas em cm a partir de altura (cm), peso (kg) e idade. */
function estimate(height, weight, age, fit) {
  const bmi = weight / Math.pow(height / 100, 2);

  const bust = 0.36 * weight + 0.28 * height + 0.05 * age + 12.4;
  const waist = 0.52 * weight + 0.16 * height + 0.14 * age - 12.8;
  const hip = 0.38 * weight + 0.32 * height + 0.02 * age + 8.6;

  /* Caimento: ajustado encosta no corpo, confortável abre folga. */
  const ease = fit === 'confortavel' ? 4 : 1;

  return {
    bmi: Math.round(bmi * 10) / 10,
    bust: Math.round(bust + ease),
    waist: Math.round(waist + ease),
    hip: Math.round(hip + ease)
  };
}

function within(value, min, max) {
  if (min == null || max == null) return null;
  return value >= min && value <= max;
}

class FitConcierge extends HTMLElement {
  connectedCallback() {
    this.steps = Array.from(this.querySelectorAll('.fit__step'));
    this.current = 0;
    this.state = { fit: 'ajustado' };

    this.min = this.readJson('data-medidas-min');
    this.max = this.readJson('data-medidas-max');

    this.addEventListener('click', (event) => {
      const next = event.target.closest('[data-fit-next]');
      const back = event.target.closest('[data-fit-back]');
      const fit = event.target.closest('[data-fit-option]');

      if (fit) {
        this.state.fit = fit.dataset.fitOption;
        this.querySelectorAll('[data-fit-option]').forEach((b) =>
          b.setAttribute('aria-pressed', String(b === fit))
        );
      }
      if (next) this.go(this.current + 1);
      if (back) this.go(this.current - 1);
    });
  }

  readJson(attribute) {
    try {
      return JSON.parse(this.getAttribute(attribute) || 'null');
    } catch (e) {
      return null;
    }
  }

  go(index) {
    if (index === 2) {
      const height = Number(this.querySelector('[name="fit-height"]').value);
      const weight = Number(this.querySelector('[name="fit-weight"]').value);
      const age = Number(this.querySelector('[name="fit-age"]').value || 30);
      if (!height || !weight) return;
      this.render(estimate(height, weight, age, this.state.fit));
    }
    this.current = Math.max(0, Math.min(index, this.steps.length - 1));
    this.steps.forEach((step, i) => step.classList.toggle('is-active', i === this.current));
  }

  render(result) {
    this.querySelector('[data-fit-bust]').textContent = `${result.bust} cm`;
    this.querySelector('[data-fit-waist]').textContent = `${result.waist} cm`;
    this.querySelector('[data-fit-hip]').textContent = `${result.hip} cm`;

    const verdict = this.querySelector('[data-fit-verdict]');
    if (!this.min || !this.max) {
      verdict.textContent = this.dataset.verdictUnknown || '';
      return;
    }
    const checks = [
      within(result.bust, this.min.busto, this.max.busto),
      within(result.waist, this.min.cintura, this.max.cintura),
      within(result.hip, this.min.quadril, this.max.quadril)
    ].filter((v) => v !== null);

    const allFit = checks.length > 0 && checks.every(Boolean);
    verdict.textContent = allFit
      ? this.dataset.verdictOk || ''
      : this.dataset.verdictAtelier || '';
  }
}
customElements.define('fit-concierge', FitConcierge);
